import "./App.css";
import {

  BrowserRouter as Router,

} from "react-router-dom";



import LandingRoutes from "./routes/LandingRoutes";
import 'swiper/css';




function App() {
  
  
  return (
    <div className="">
     
      <Router>
       
        <LandingRoutes />

      </Router>
    </div>
  );
}

export default App;
